export default class TimeAgo {

  constructor(time) {
    this.time = time

    this.rtf = new Intl.RelativeTimeFormat('de')
    this.now = new Date()

    this.seconds = (this.now - this.time) / 1000
    this.minutes = this.seconds / 60
    this.hours = this.minutes / 60
    this.days = this.hours / 24
    this.years = this.days / 365
  }

  beyond(value, unit) {
    if (!unit.endsWith('s')) unit += 's' // use e.g 'hours' when called with 'hour'

    return this[unit] >= value
  }

  humanized() {
    if (this.minutes < 1) {
      return this.rtf.format(Math.round(-this.seconds), 'seconds')
    } else if (this.hours < 1) {
      return this.rtf.format(Math.round(-this.minutes), 'minutes')
    } else if (this.days < 1) {
      return this.rtf.format(Math.round(-this.hours), 'hours')
    } else if (this.years < 1) {
      return this.rtf.format(Math.round(-this.days), 'days')
    } else {
      return this.rtf.format(Math.round(-this.years), 'years')
    }
  }

}
